<div class="quote-details_row">
  <div class="quote-details_column -symbol-info">
    <div class="quote-details_column -symbol-name" [class.-wide]="doHideLastPriceInfo">
      <div class="quote-details_label -security-symbol"
        [class.-ext-0]="quoteDetails.securityNameExplained.expirationDateStr"
        textHiding
        [tooltip]="quoteDetails.securityNameExplained.symbol">
        <span [innerHTML]="quoteDetails.securityNameExplained.symbol || quoteDetails.symbol || mdash"></span>
      </div>
      @if (quoteDetails.securityNameExplained.expirationDateStr) {
        <div class="quote-details_label -security-symbol -ext-1"
          textHiding
          [tooltip]="quoteDetails.securityNameExplained.expirationDateStr">
          <span>
            {{quoteDetails.securityNameExplained.expirationDateStr}}
          </span>
        </div>
      }
      @if (quoteDetails.securityNameExplained.optionTypeStr) {
        <div class="quote-details_label -security-symbol -ext-1 -opt-type-strike"
          textHiding
          [tooltip]="(quoteDetails.securityNameExplained.optionTypeStr | l10n) + '-' + quoteDetails.securityNameExplained.strikeStr">
          <span>
            {{(quoteDetails.securityNameExplained.optionTypeStr | l10n) + '-' + quoteDetails.securityNameExplained.strikeStr}}
          </span>
        </div>
      }
      <div class="quote-details_label -security-name"
      [innerHTML]="quoteDetails.securityName || ''"></div>
    </div>
    @if (!doHideLastPriceInfo) {
      <div class="quote-details_column -price-info">
        <div class="quote-details_label -trade-price" textHiding>
          <span [ngClass]="quoteDetails.tradePrice.class"
          [innerHTML]="quoteDetails.tradePrice.value || ''"></span>
        </div>
        <div class="quote-details_label -trade-price-change"
          [ngClass]="displayQuote ? displayQuote.tradePrice.animationClasses : ''">
          <div [ngClass]="quoteDetails.changeValue.class" [innerHTML]="quoteDetails.changeValue.value || ''"></div>
          <div>
            <span [ngClass]="quoteDetails.changePercent.class" [innerHTML]="quoteDetails.changePercent.value || ''"></span><span>{{isPercentSymbolNeeded ? '%' : ''}}</span>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="quote-details_column -volume-info">
    <div class="quote-details_column -small">
      <div class="quote-details_label -bottom-indent -bid">{{'components.widgets.order-details-widget.bid' | l10n}}</div>
      <div class="quote-details_value -bid"
        [ngClass]="displayQuote ? displayQuote.bid.price.animationClasses : ''">
        <div [ngClass]="quoteDetails.bidPrice.class" [innerHTML]="quoteDetails.bidPrice.value || ''"></div>
        <div class="quote-details_value_x">x</div>
        <div [ngClass]="quoteDetails.bidVolume.class" [innerHTML]="quoteDetails.bidVolume.value || ''"></div>
      </div>
    </div>
    <div class="quote-details_column -small">
      <div class="quote-details_label -bottom-indent -ask">{{'components.widgets.order-details-widget.ask' | l10n}}</div>
      <div class="quote-details_value"
        [ngClass]="displayQuote ? displayQuote.ask.price.animationClasses : ''">
        <div [ngClass]="quoteDetails.askPrice.class" [innerHTML]="quoteDetails.askPrice.value || ''"></div>
        <div class="quote-details_value_x">x</div>
        <div [ngClass]="quoteDetails.askVolume.class" [innerHTML]="quoteDetails.askVolume.value || ''"></div>
      </div>
    </div>
  </div>
</div>
